// WebSocket.js

import React, { createContext } from 'react'
import io from 'socket.io-client';
import { SOCKET_HOST } from '../../app.config';
import { useDispatch, useSelector } from 'react-redux';

import { messageReceived, sendMessage } from '../../store/actions';

const WebSocketContext = createContext(null)

export { WebSocketContext }

export default ({ children }) => {
    let socket;
    let ws;

    const user = useSelector(state => state.Auth.user);

    const dispatch = useDispatch();

    if (user && user._id) {
        socket = io(SOCKET_HOST);
        socket.emit("add-user", user._id);

        socket.on("msg-receive", ({chatId, message}) => {
			console.log('Socket: event msg-receive', chatId, message);
            dispatch(messageReceived(chatId, message));
        });

        ws = {
            socket: socket,
            sendMessage: ({chatId, to, message}) => {
                socket.emit("send-msg", {
                    chatId,
                    to,
                    message,
                    from: user._id
                });
                dispatch(sendMessage(chatId, message));
            }
        }
    }

    return (
        <WebSocketContext.Provider value={ws}>
            {children}
        </WebSocketContext.Provider>
    )
}